import React, { Component } from "react";
import PropTypes from "prop-types";
import Radium from "radium";
import { semanticColors, greyScaleColors } from "../../../Globals/styles";
import Chat from "../../../Project/RegisterActivities/Chat";
import { Scrollbars } from "react-custom-scrollbars";
import HeadingSubtextContainer from "../../../HeadingSubtext/HeadingSubtextContainer";
import Modal from "../../../Common/modal";

import {
  attemptCreateEditWorkplace,
  attemptGetWorkplace,
  attemptDeleteWorkplace,
  attemptGetDailyReports,
  attemptDailyReportToggleApproved,
  attemptDailyReportToggleInvoiced,
  attemptDailyReportToggleBog,
  isProjectNumberReserved,
  getProjectSuggestions,
  getClientSuggestions,
  getContactSuggestions,
  setInitState,
  addHeadingSubtext_worx,
  updateHeading_worx,
  updateSubtext_worx
} from "./actions";
import { setDate } from "../DailyReport/actions";
import { routeActions } from "redux-simple-router";
import { connect } from "react-redux";
import DailyReportsList from "./dailyReportsList";
import Waves from "node-waves";
import FirstColumnForm from "./firstColumnForm";
import Tasks from "./Tasks";
import { attemptGetWorkplaceFeed } from "./Feed/actions";
import Feeds from "./Feed";
import * as desriptionActions from "./description/actions";
import DescriptionForm from "./description/form";

import auth from "../../../Login/authService";

class Overview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isFirstColumnEdit: false,
      hide: true
    };
  }

  openPdf = (pdfUrl, base64) => {
    if (base64) {
      this.setState({
        hide: false,
        document: { base64: "data:application/pdf;base64, " + base64 }
      });
    } else {
      this.setState({
        hide: false,
        document: { url: pdfUrl }
      });
    }
  };

  componentWillMount = () => {
    const { params, dispatch } = this.props;
    // eslint-disable-next-line
    if (params.workplaceId == "opret") {
      this.setState({
        isCreate: true,
        isFirstColumnEdit: true
      });
    } else {
      dispatch(desriptionActions.getPictures(params.workplaceId));
      dispatch(attemptGetWorkplace(params.departmentId, params.workplaceId));
      dispatch(attemptGetDailyReports(params.workplaceId, true));
    }
  };
  componentWillUnmount = () => {
    // this.props.dispatch(setInitState());
  };
  componentDidMount = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  componentDidUpdate = () => {
    Waves.attach(".waves-btn", ["waves-button"]);
    Waves.attach(".waves-icon", ["waves-circle"]);
  };
  componentWillReceiveProps = nextProps => {
    // eslint-disable-next-line
    if (
      nextProps.params.workplaceId != this.props.params.workplaceId &&
      this.state.isCreate &&
      nextProps.params.workplaceId != "opret"
    ) {
      this.setState({
        isCreate: false
      });
    }
    if (this.props.isSavingWorkplace && !nextProps.isSavingWorkplace) {
      this.setState({
        isFirstColumnEdit: false
      });
    }
  };
  onSave = () => {
    //if the form is not valid do nothing
  };
  onScrollFirstColumn = evt => {
    const { params, dispatch } = this.props;
    // eslint-disable-next-line
    if (evt.top == 1) {
      dispatch(attemptGetDailyReports(params.workplaceId));
    }
  };
  onScrollSecondColumn = evt => {
    const { params, dispatch } = this.props;
    // eslint-disable-next-line
    if (evt.top == 1) {
      dispatch(attemptGetWorkplaceFeed(params.workplaceId));
    }
  };
  userCanEdit = () => {
    // eslint-disable-next-line
    return auth.getProfile().role !== "Formand";
  };
  goToDailyReport = (date, id) => {
    const { params, dispatch } = this.props;
    dispatch(setDate(date, id));
    dispatch(
      routeActions.push(
        "/afdeling/" +
        params.departmentId +
        "/arbejdssted/" +
        params.workplaceId +
        "/dagrapport"
      )
    );
  };
  toggleEditFirstColumn = () => {
    if (!this.state.isCreate)
      //load in the workplace data in the form object
      this.setState({
        isFirstColumnEdit: !this.state.isFirstColumnEdit
      });
  };
  getFirstColumnFormDefaults = () => {
    const { workplace } = this.props;
    return {
      project: {
        id: workplace.project.id,
        name: workplace.project.name,
        number: workplace.project.number
      },
      workplace: {
        name: workplace.name
      },
      client: {
        ...workplace.client
      }
    };
  };

  render() {
    const {
      workplace,
      dailyReports,
      dispatch,
      params,
      approvementCount,
      projectNumberReserved,
      projectSuggestions,
      clients,
      clientSuggestions,
      contactSuggestions,
      isSavingWorkplace,
      description,
      isLoading
    } = this.props;
    const { isCreate } = this.state;
    return (
      <div className="row" style={styles.body}>
        {this.state.isFirstColumnEdit || isCreate ? (
          <div style={styles.firstOverlay} />
        ) : null}
        {description.form.active ? (
          <div>
            <div style={styles.secondOverlay} />
            <div style={styles.thirdOverlay} />
          </div>
        ) : null}

        <Modal
          hide={this.state.hide}
          onClose={() => {
            this.setState({ hide: !this.state.hide });
          }}
        >
          {this.state.document ? (
            this.state.document.base64 ? (
              <iframe
                title="dpf1"
                scrolling="no"
                width="100%"
                height="95%"
                src={this.state.document.base64}
              ></iframe>
            ) : (
                <iframe
                  title="dpdf1"
                  scrolling="no"
                  width="100%"
                  height="95%"
                  src={
                    "https://docs.google.com/viewer?url=" +
                    this.state.document.url +
                    "&embedded=true"
                  }
                ></iframe>
              )
          ) : null}
        </Modal>

        <div className="col-xs-4" style={styles.leftContainer}>
          {/* Left Content*/}

          {this.state.isFirstColumnEdit || isCreate ? (
            <div>
              <FirstColumnForm
                defaultValues={
                  isCreate ? null : this.getFirstColumnFormDefaults()
                }
                toggleEdit={
                  isCreate
                    ? () =>
                      dispatch(
                        routeActions.push("/afdeling/" + params.departmentId)
                      )
                    : this.toggleEditFirstColumn
                }
                getProjectSuggestions={val =>
                  dispatch(getProjectSuggestions(val))
                }
                projectNumberReserved={projectNumberReserved}
                isProjectNumberReserved={projectNumber =>
                  dispatch(isProjectNumberReserved(projectNumber))
                }
                projectSuggestions={projectSuggestions}
                saveWorkplace={payload =>
                  dispatch(
                    attemptCreateEditWorkplace(
                      params.departmentId,
                      payload,
                      isCreate ? null : workplace.id,
                      this.props.workplace.headsub
                        ? this.props.workplace.headsub
                        : [{ heading: "", subtext: "", editMode: true }]
                    )
                  )
                }
                deleteWorkplace={() =>
                  dispatch(
                    attemptDeleteWorkplace(workplace.id, params.departmentId)
                  )
                }
                clients={clients}
                getClientSuggestions={val =>
                  dispatch(getClientSuggestions(val))
                }
                clientSuggestions={clientSuggestions}
                getContactSuggestions={(val, clientId) =>
                  dispatch(getContactSuggestions(val, clientId))
                }
                contactSuggestions={contactSuggestions}
                isSavingWorkplace={isSavingWorkplace}
                isLoading={isLoading}
                isCreate={isCreate}
                headingSubtexts={this.props.workplace.headsub}
                updateSubtext={(text, index) =>
                  this.props.dispatch(updateSubtext_worx(text, index))
                }
                updateHeading={(text, index) =>
                  this.props.dispatch(updateHeading_worx(text, index))
                }
                addHeadingSubtext={() =>
                  this.props.dispatch(addHeadingSubtext_worx())
                }
              />
            </div>
          ) : (
              <Scrollbars onScrollFrame={this.onScrollFirstColumn}>
                <div style={styles.middleInnerContainer}>
                  <div style={styles.divideSections}>
                    <div
                      className="waves-btn"
                      style={styles.iconContainer}
                      onClick={this.toggleEditFirstColumn}
                    >
                      <i className="fa fa-pencil" style={styles.pencil}></i>
                      <div style={styles.iconLabel}>Rediger</div>
                    </div>
                    <div style={styles.informationBoxes}>
                      <div style={styles.stamdata}>Stamdata</div>
                      <div style={styles.informationSubtitle}>Sag</div>
                      <div style={styles.informationDetails}>
                        {" "}
                        {workplace.project.number} <br /> {workplace.project.name}{" "}
                      </div>
                    </div>
                    <div style={styles.informationBoxes}>
                      <div style={styles.informationSubtitle}>Bygherre </div>
                      <div style={styles.informationDetails}>
                        {" "}
                        {workplace.client
                          ? workplace.client.name
                          : "fejl"} <br />{" "}
                        {workplace.client
                          ? workplace.client.contact.name
                          : "fejl"}{" "}
                      </div>
                    </div>
                    <div style={styles.informationBoxes}>
                      <div style={styles.informationSubtitle}>
                        ID / Arbejdssted{" "}
                      </div>
                      <div style={styles.informationDetails}>
                        {" "}
                        {workplace.name}{" "}
                      </div>
                    </div>
                    <HeadingSubtextContainer
                      headingSubtexts={this.props.workplace.headsub}
                      updateSubtext={(text, index) =>
                        this.props.dispatch(updateSubtext_worx(text, index))
                      }
                      updateHeading={(text, index) =>
                        this.props.dispatch(updateHeading_worx(text, index))
                      }
                      addHeadingSubtext={() =>
                        this.props.dispatch(addHeadingSubtext_worx())
                      }
                      style={{
                        position: "relative",
                        zIndex: 99,
                        width: "100%",
                        backgroundColor: "rgb(247, 247, 247)"
                      }}
                      subContainerStyle={{ width: "96%" }}
                      headingStyle={{
                        fontSize: 12,
                        fontWeight: 500,
                        width: "100%",
                        backgroundColor: "rgb(247, 247, 247)",
                        paddingLeft: 0
                      }}
                      subtextStyle={{
                        marginTop: 8,
                        marginBottom: 10,
                        backgroundColor: "rgb(247, 247, 247)",
                        border: "none",
                        borderRadius: "2px",
                        width: "100%",
                        paddingLeft: 10
                      }}
                      noedit
                      dontAllowNewRow
                    />
                  </div>

                  <DailyReportsList
                    dailyReports={dailyReports}
                    toggleApproved={(
                      dailyReportIndex,
                      dailyReportId,
                      approved
                    ) => {
                      if (this.userCanEdit())
                        dispatch(
                          attemptDailyReportToggleApproved(
                            dailyReportIndex,
                            dailyReportId,
                            approved
                          )
                        );
                    }}
                    toggleInvoiced={(
                      dailyReportIndex,
                      dailyReportId,
                      invoiced
                    ) => {
                      if (this.userCanEdit())
                        dispatch(
                          attemptDailyReportToggleInvoiced(
                            dailyReportIndex,
                            dailyReportId,
                            invoiced
                          )
                        );
                    }}
                    toggleBog={(dailyReportIndex, dailyReportId, bog) => {
                      if (this.userCanEdit())
                        dispatch(
                          attemptDailyReportToggleBog(
                            dailyReportIndex,
                            dailyReportId,
                            bog
                          )
                        );
                    }}
                    workplaceId={params.workplaceId}
                    approvementCount={approvementCount}
                    goToDailyReport={this.goToDailyReport}
                  />
                </div>
              </Scrollbars>
            )}
        </div>

        {/* Middle Content*/}
        <div className="col-xs-4" style={styles.middleContainer}>
          <Scrollbars onScrollFrame={this.onScrollSecondColumn}>
            <div style={styles.middleInnerContainer}>
              <div style={[styles.divideSections]}>
                <div style={styles.divideSections}>Beskrivelse</div>
                {description.form.active ? (
                  <DescriptionForm
                    defaultValue={{
                      text: description.text,
                      pics: { ...description.pics }
                    }}
                    isSubmitting={description.form.isSubmitting}
                    onSubmit={state => {
                      dispatch(
                        desriptionActions.submit(params.workplaceId, state)
                      );
                    }}
                    onClose={() => dispatch(desriptionActions.edit(false))}
                  />
                ) : (
                    <div>
                      <div style={styles.divideSections}>{description.text}</div>
                      <div>
                        <div
                          className="waves-btn"
                          style={styles.iconContainer}
                          onClick={() => {
                            dispatch(desriptionActions.edit(true));
                          }}
                        >
                          <i className="fa fa-pencil" style={styles.pencil}></i>
                          <div style={styles.iconLabel}>Rediger</div>
                        </div>
                      </div>
                      {description.pics.map((pic, i) => {
                        if (pic && pic.id != null) {
                          return (
                            <div
                              key={pic.id}
                              className="waves-btn"
                              style={styles.uploadedPictures}
                              onTouchEnd={() => {
                                if (pic.original.startsWith("http")) {
                                  this.openPdf(pic.original);
                                } else {
                                  this.openPdf("", pic.original);
                                }
                              }}
                              onClick={() => {
                                if (pic.original.startsWith("http")) {
                                  this.openPdf(pic.original);
                                } else {
                                  window.open(
                                    "data:application/pdf;base64, " + pic.original
                                  );
                                }
                              }}
                            >
                              <i
                                className="fa fa-file-pdf-o fa-2x"
                                aria-hidden="true"
                                style={[styles.picUpload, styles.coverImage]}
                              ></i>
                              <div>
                                {pic.description ? pic.description : "Åben pdf"}
                              </div>
                            </div>
                          );
                        } else {
                          return null;
                        }
                      })}
                    </div>
                  )}
              </div>

              {description.activeBigPic.isVisible ? (
                <div className="text-center">
                  <img
                    src={
                      description.pics[description.activeBigPic.index].original
                    }
                    style={{ margin: "auto" }}
                    className="img-responsive"
                    alt="billede"
                  />
                </div>
              ) : (
                  <div>
                    {description.form.active ? null : (
                      <div>
                        <div style={styles.divideSections}>
                          <div style={styles.sectionTitles}>Opgaver</div>
                          {isCreate ? null : (
                            <Tasks workplaceId={params.workplaceId} />
                          )}
                        </div>
                        <div style={styles.categoriesPadding}>
                          <div style={styles.sectionTitles}>Aktivitetsfeed </div>
                          {isCreate ? null : (
                            <Feeds
                              workplaceId={params.workplaceId}
                              goToDailyReport={this.goToDailyReport}
                            />
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                )}
            </div>
          </Scrollbars>
        </div>

        <div className="col-xs-4" style={styles.rightContainer}>
          {" "}
          {/* Right Content*/}
          {isCreate ? null : <Chat activityId={params.workplaceId} />}
        </div>
      </div>
    );
  }
}

var styles = {
  test: { width: "100%" },
  body: {
    height: "100%",
    padding: "20px 0px"
  },
  leftContainer: {
    borderRight: "1px solid",
    borderColor: semanticColors.mainBackground,
    height: "100%",
    paddingRight: "0px"
  },
  middleContainer: {
    borderRight: "1px solid",
    borderColor: semanticColors.mainBackground,
    height: "100%",
    paddingRight: "0"
  },
  middleInnerContainer: {
    paddingRight: "12px"
  },
  rightContainer: {
    height: "100%"
  },
  iconContainer: {
    fontSize: "22px",
    height: "45px",
    width: "50px",
    padding: "0px",
    textAlign: "center",
    position: "absolute",
    top: "0",
    right: "12px",
    zIndex: "2",
    lineHeight: "20px"
  },
  pencil: {
    display: "inline-block",
    width: "30px",
    height: "30px",
    lineHeight: "30px",
    cursor: "pointer"
  },
  floppy: {
    display: "inline-block",
    width: "30px",
    height: "30px",
    lineHeight: "30px",
    cursor: "pointer"
  },
  picUpload: {
    border: "1px solid" + greyScaleColors.greyLighter,
    borderRadius: "2px"
  },
  coverImage: {
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    backgroundPosition: "center"
  },
  pencilActive: {
    color: semanticColors.info
  },
  borderActive: {
    border: "2px solid " + semanticColors.info
  },
  img: {
    width: "100%",
    paddingBottom: "5px",
    borderRadius: "2px"
  },
  input: {
    fontSize: "16px",
    height: "35px",
    width: "100%",
    border: "none",
    paddingLeft: "5px",
    borderRadius: "2px",
    boxShadow:
      "0 1px 2px rgba(0,0,0,0.2) inset, 0 -1px 0 rgba(0,0,0,0.05) inset"
  },
  textarea: {
    width: "100%",
    borderColor: greyScaleColors.greyLighter
  },
  picPlaceholder: {
    border: "1px solid" + greyScaleColors.greyLighter,
    borderRadius: "2px",
    backgroundColor: "#fff",
    color: greyScaleColors.greyLight,
    height: "140px",
    marginBottom: "10px",
    textAlign: "center",
    lineHeight: "140px"
  },
  picturesContainer: {
    width: "50%",
    paddingRight: "12px",
    paddingTop: "10px",
    display: "inline-block"
  },
  pictureContainerRight: {
    paddingRight: "0px",
    paddingLeft: "12px"
  },
  uploadedPictures: {
    width: "50%",
    display: "inline-block",
    padding: "5px"
  },
  noPadding: {
    padding: "0px"
  },
  fjernBtn: {
    display: "inline-block",
    width: "48%",
    padding: "0px",
    lineHeight: "35px"
  },
  divider: {
    display: "inline-block",
    width: "4%"
  },
  erstat: {
    display: "inline-block",
    width: "48%",
    padding: "0px",
    lineHeight: "35px"
  },
  uploadBtn: {
    display: "inline-block",
    width: "100%",
    padding: "0px",
    lineHeight: "35px"
  },
  projectSmallText: {
    fontSize: "12px",
    fontWeight: "500"
  },
  formLabels: {
    color: greyScaleColors.greyLight
  },
  informationDetailsEdit: {
    paddingBottom: "10px"
  },
  suggestProjectContainer: {
    width: "50%"
  },
  createProjectContainer: {
    lineHeight: "35px",
    textAlign: "right",
    paddingRight: "38px",
    position: "relative",
    fontSize: "12px"
  },
  createProjectPlusIcon: {
    fontSize: "20px",
    position: "absolute",
    top: "8px",
    right: "15px"
  },
  editProjectContainer: {
    minHeight: "150px"
  },
  inputLabel: {
    fontSize: "11px"
  },
  spinner: {
    width: "20px",
    height: "20px"
  },
  iconLabel: {
    fontSize: "12px",
    fontWeight: "600",
    marginTop: "-3px"
  },
  divideSections: {
    position: "relative",
    marginBottom: "30px"
  },
  informationBoxes: {
    paddingBottom: "15px"
  },
  informationSubtitle: {
    fontSize: "12px",
    paddingBottom: "15px"
  },
  informationDetails: {
    paddingLeft: "10px"
  },
  stamdata: {
    paddingBottom: "5px"
  },
  sectionTitles: {
    paddingBottom: "10px"
  },
  firstOverlay: {
    position: "absolute",
    left: "0",
    top: "0",
    width: "100%",
    height: "100%",
    zIndex: "55",
    backgroundColor: semanticColors.default,
    opacity: "0.5"
  },
  secondOverlay: {
    position: "absolute",
    left: "0",
    top: "0",
    width: "33%",
    height: "100%",
    zIndex: "50",
    backgroundColor: semanticColors.default,
    opacity: "0.5"
  },
  thirdOverlay: {
    position: "absolute",
    right: "0",
    top: "0",
    width: "33%",
    height: "100%",
    zIndex: "50",
    backgroundColor: semanticColors.default,
    opacity: "0.5"
  }
};

const selectProps = state => {
  return {
    ...state.workplaceOverviewReducer,
    description: state.workplaceOverviewDescriptionReducer
  };
};

Overview.propTypes = {
  isCreate: PropTypes.bool,
  workplace: PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    client: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      contact: PropTypes.shape({
        id: PropTypes.string.isRequired,
        name: PropTypes.string.isRequired
      }).isRequired
    }).isRequired,
    project: PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      number: PropTypes.string.isRequired
    }).isRequired
  }),
  isLoading: PropTypes.bool.isRequired,
  projectNumberReserved: PropTypes.shape({
    projectNumber: PropTypes.string.isRequired,
    reserved: PropTypes.bool.isRequired
  }).isRequired,
  clientSuggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  contactSuggestions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired
    })
  ),
  contactExists: PropTypes.string,
  isSavingWorkplace: PropTypes.bool.isRequired
};

export default connect(selectProps)(Radium(Overview));



// WEBPACK FOOTER //
// ./src/App/ShortTermProjects/Workplace/Overview/index.jsx